import { Injectable } from '@angular/core';
import { NotificationDataEntry } from '@osos/shared/api';
import { AccessRightLevelEnum } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

import { NotificationPresenterModel } from '@osos/shared/types';

@Injectable()
export class NotificationParserV1Service extends ParserBase<
  NotificationDataEntry,
  NotificationPresenterModel
> {
  nonePermission = {
    value: { level: AccessRightLevelEnum.None },
  };
  constructor() {
    super(NotificationDataEntry, NotificationPresenterModel, 1);
  }

  getPresenterModel(model: NotificationDataEntry): NotificationPresenterModel {
    return {
      specificationVersion: this.version,
      id: model.id,
      title: model.value.title,
      content: model.value?.content,
      readAt: model.value?.readAt,
      icon: model.value?.icon,
      creationInfo: model.creationInfo,
      module: model?.value?.module,
      reference: model?.value?.reference,
      attachment: model?.value?.attachment,
    } as NotificationPresenterModel;
  }
  getDataModel(presenter: NotificationPresenterModel): NotificationDataEntry {
    throw new Error('Method not implemented.');
  }
}
